import type {DataExtension, RawDataObj} from '../../../types';
import {searchFieldAlias} from '@packages/systems/search';

export const getDataExtension: DataExtension = (element, dynamoData) => {
  const data = dynamoData.getDataForElement(element);
  const searchAlias = searchFieldAlias(element.id);

  if (!data || Array.isArray(data) || !(searchAlias in data)) {
    return data;
  }

  const rawData = data as RawDataObj;
  const searchData = rawData[searchAlias] ?? null;

  return {
    site: {
      search: searchData,
    },
  };
};
